
<template>
  <div>
    <modality-index></modality-index>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'Modality',
  components: {
    ModalityIndex: ()=>import('@/_backoffice/_registrations/components/modality/ModalityIndex.vue'),
  },
}
</script>

<style scoped>

</style>